module.exports = __webpack_public_path__ + "media/images/intro_slide_img_03-f93ecd6cc601ae7d22563ddb59746774.jpg";